import { useSyncExternalStore } from "react";
import { getSnapshot, subscribe } from "./SessionStore";

export function useSession() {
  const state = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return {
    initialized: state.initialized,
    session: state.session,
    hasRole: (role: string) => state.session.hasRole(role),
    hasPrivilege: (privilege: string) => state.session.hasPrivilege(privilege),
  };
}
